export default "__VITE_ASSET__DuH1iEm5__"